import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, RadioGroup, Link, StepLabel,
  Paper,Autocomplete, Radio, Checkbox, Box, ListSubheader,List,
  Button, MenuItem, InputLabel,Select, FormControl, FormHelperText, FormGroup, FormControlLabel, ListItem,
} from '@mui/material';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import {  
  createApplication,
  fetchApplication,
  fetchAllApplications,
  selectApplicationById,
  selectApplicationStatus,
  selectApplicationError} from '../store/applicationSlice' 

import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllFloors,
}  from '../store/floorSlice'

import {
  selectAllReasons,
} from '../store/reasonSlice'


import useCurrentPath from '../utils/useCurrentPath'

import {useAppAuthContext} from '../utils/AppAuthContext'

//import TimePicker from '@mui/lab/TimePicker';
import { DesktopDatePicker , DatePicker} from '@mui/x-date-pickers';
import { DateTimePicker  as DesktopDateTimePicker } from '@mui/x-date-pickers'
//import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
//import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'


import { visitorsSyncLoaded,
    selectVisitorById,
  selectVisitorByEmail, fetchAllVisitors } from '../store/visitorSlice';

import { format, set } from 'date-fns';

//import ReoccurenceIcon from '@mui/icons-material/ReplayCircleFilled';
import PersonView from './PersonView';
import ReoccurenceDialog from './ReoccurenceDialog'

import ClockIcon from '@mui/icons-material/Schedule';

import DataListProvider, {useDataListContext} from '../utils/DataListContext'

import {usePlayContext} from '../utils/PlayContext';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { createVisitor, selectAllVisitors, selectAllCompanies, selectAllEmails, selectAllPhones }
from '../store/visitorSlice';

import {getTimeStr, getDateISOString, 
  getDateTime, getValidEndTimes, allStartTimes, allEndTimes,
   getAllDays, getWeekDayName} from '../utils/timeConfig'


import {regexEmail} from '../utils/ValidationConst';


const ApplyPageInternal = ({action, visitor_id, invitation_id}) => {

  const [timeMode, setTimeMode] = useState('normal')
  const [reoccurence, setReoccurence] = useState(undefined)


  const [activeStep, setActiveStep] = useState(0)
  const navigate = useNavigate()
  const allEmails = useSelector(selectAllEmails)

  const {
      op, setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
       openSnackToast
    }=usePlayContext()

    const {vmsConfig} = useAppAuthContext()

    
  

  const {initDataList, clearDataList, listData} = useDataListContext()
  const dispatch = useDispatch()
  const sites = useSelector(selectAllFloors)
  const visit_reasons = useSelector(selectAllReasons)

  const [startDate, setStartDate] = useState(null)
  const [startDateError, setStartDateError] = useState('')
  const [startTime, setStartTime] = useState('')
  const [startTimeError, setStartTimeError] = useState('')
  const [endDate, setEndDate] = useState(null)
  const [endDateError, setEndDateError] = useState('')
  const [endTime, setEndTime] = useState('')
  const [endTimeError, setEndTimeError] = useState('')

  // const [startDateTime, setStartDateTime] = useState(null);
  // const [startDateTimeError, setStartDateTimeError] = useState('');
  // const [endDateTime, setEndDateTime] = useState(null);
  // const [endDateTimeError, setEndDateTimeError] = useState('');
   const [reoccurenceError, setReoccurenceError] = useState('');

  const [remarks, setRemarks] = useState('');
  const [remarksError, setRemarksError] = useState('');

const [myGroup, setMyGroup] = useState(false);
  

  const [site, setSite] = useState(sites&&sites.length>0 ? sites[0].name:'');

  const [siteError, setSiteError] = useState('');

  const [reasonVisit, setReasonVisit] = useState('');
  const [reasonVisitError, setReasonVisitError] = useState('');


  const [groupSize, setGroupSize] = useState(2);
  const [groupSizeError, setGroupSizeError] = useState('');

  const [groupSendTo, setGroupSendTo] = useState('');
  const [groupSendToError, setGroupSendToError] = useState('');

  
  const myInvitation = useSelector(selectApplicationById(invitation_id))
  const myVisitor = useSelector(selectVisitorById(visitor_id))

  console.log("myInvitation="+myInvitation)
  console.log("myVisitor="+myVisitor)

  
  
  const doFetchData = async (action)=>{
    setStatus('processing')
    try
    {
        let respAllVisitors = await dispatch(fetchAllVisitors()).unwrap();

        if (action==='reinvite' || action==='edit')
        {
            
            let respInvited = await dispatch(fetchApplication(invitation_id)).unwrap();
            //alert("respInvited=="+invitation_id)
            console.log("respInvited==respInvited==respInvited==")
            console.log(respInvited)

            if ((action==='edit' || action==='reinvite') && respInvited)
            {
              initDataList(respInvited.invitationVisitors)
            }

        }
        else if (action==='invite')
        {
          //alert("respVisitor=="+visitor_id)
          if (myVisitor)
          {
              let xxx = {
                  visitorId: myVisitor.id, 
                  name:  myVisitor.name,
                  phone: myVisitor.phone,
                  company:myVisitor.company,
                  email: myVisitor.email
              }
              initDataList([xxx])
          }
        }
        setStatus('idle')
    }
    catch (ex)
    {
      setStatus('error')
      setErrorMessage("Cannot retrieve Visitor info")
    } 
  }


  //const maxStartDay = new Date(Date.now()+3600*24*1000 *vmsConfig.maxInvitationAdvanceDays)
  
  // const getMaxEndDateTime=()=>
  // {
  //     let start=startDateTime
  //     if (!Boolean(start) || isNaN(start))
  //     {
  //       start = new Date();
  //     }
  //     return new Date(start.getTime()+3600*24*1000 *vmsConfig.maxInvitationDays)
    
  // }


  
  useEffect(() => {
    setAppTitle( ['Invitations', 'Invite Visitors'])
    setErrorMessage('')
    setErrorTitle('')

    setOp('')


    //initDataList(persons)

    doFetchData(action);

    if (action==='reinvite')
    {
        if (myInvitation)
        {
          
            setSite(myInvitation.floor)
            setReasonVisit(myInvitation.reason)
            setRemarks(myInvitation.remarks)
        }

    }
    else if (action==='invite')
    {
      
    

    }
    else  if (action==='edit')
    {
      setSite(myInvitation.floor)
      setReasonVisit(myInvitation.reason)
      setReasonVisit(myInvitation.remarks)
      // setStartDateTime(myInvitation.startDateTime)
      // setEndDateTime(myInvitation.endDateTime)
    }
    

    return () => {
      //alert("clean up ApplyPage")
      setOp('')
      clearDataList();
    }

  }, [])

  const onCancelClicked = ()=>
  {
      if (visitor_id || invitation_id)
      {
        navigate(-1)    
      }
      navigate('/invitations')
  }

  const onTimeModeChanged = (value)=>
  {
      if ('normal'===value)
      {
        setReoccurence(undefined) 
        setReoccurenceError('')
      }
      else
      {
          setStartDate(null)
          setStartTime('')
          setStartDateError('')
          setStartTimeError('')

          setEndDate(null)
          setEndTime('')
          setEndDateError('')
          setEndTimeError('')
          // setStartDateTime(null)
          // setStartDateTimeError('')
          // setEndDateTime(null)
          // setEndDateTimeError('')
      }
      setTimeMode(value)
  }

   
 
   const onSendInviteClicked = async (currentStep)=>
   {
      //alert("currentStep="+currentStep)
      let errNo=0
      setErrorMessage('')
      setErrorTitle('')

      setStartDateError('')
      setStartTimeError('')
      setEndDateError('')
      setEndTimeError('')
     

      let body={
        timeMode,
      }

      if (timeMode==='normal')
      {
        let date1 = null;
        let date2 = null;
        let time1 = null;
        let time2 = null;
        const today_date = format(new Date(),'yyyy-MM-dd') 
        const today_time = format(new Date(),'HH:mm') 

     
        if (!Boolean(startDate))
        {
            errNo++;
            setStartDateError("Start Date is required")
        }      
        else if ( !Boolean(date1=getDateISOString(startDate)))
        {
          errNo++;
          setStartDateError("Start Date is invalid") 
        }
        else  if (date1<today_date)
        {
          errNo++
          setStartDateError("Start Date cannot be earlier than current date")
        }


        if (!Boolean(endDate))
        {
            errNo++;
            setEndDateError("End Date is required")
        }      
        else if ( !Boolean(date2=getDateISOString(endDate)))
        {
          errNo++;
          setEndDateError("End Date is invalid") 
        }
        else if (date2<date1||date2<today_date)
        {
          errNo++
          setEndDateError("End Date cannot be earlier than Start Date")

        }
       
        //alert(date2+'--'+today_date)
      
        if (!Boolean(startTime))
        {
          errNo++;
          setStartTimeError("Start time is required")
        }
        else if (!Boolean(time1=getTimeStr(startTime)))
        {
          errNo++;
          setStartTimeError("Start time is invalid")
        }
       

        if (!Boolean(endTime))
        {
          errNo++;
          setEndTimeError("End time is required")
        }
        else if (!Boolean(time2=getTimeStr(endTime)))
        {
          errNo++;
          setEndTimeError("End time is invalid")
        }
      


        if (errNo>0) return

        let tmp1 = Date.parse(getDateTime(startDate, startTime));
        let tmp2 = Date.parse(getDateTime(endDate, endTime));
      
        if (tmp1<Date.now())
        {
          errNo++
          setStartTimeError("Start time cannot be earlier than current time")
          
        }
        if (tmp2<=tmp1)
        {
          errNo++
          setEndTimeError("End time cannot be earlier than start time")
          
        }
      if (errNo>0) return

      body.startTm=getDateTime(startDate, startTime)
      body.endTm=getDateTime(endDate, endTime)

      }
      else if (timeMode==='reoccurence')
      {
          if (!reoccurence?.days || reoccurence?.days.length===0)
          {
            errNo++
            setReoccurenceError('No reoccurence dates provided')
          }
          else
          {
            setReoccurenceError('')
            //body.reoccurrenceData = JSON.stringify(reoccurence);
            body.reoccurenceMessage = reoccurence.message;
            body.reoccurenceData = JSON.stringify({...reoccurence, days:undefined});
            
            body.days =reoccurence.days
          }
      }

      if (errNo>0)
      {
          setActiveStep(0)
          return
      }

      if (currentStep===0)
      {
          setActiveStep(1)
          return
      }

      if (!Boolean(site))
      {
          errNo++
          setSiteError('Floor is required')
      }  
      else 
      {
        setSiteError('')
        
      }
      if (!Boolean(reasonVisit) || !Boolean(reasonVisit.trim()))
      {
          errNo++;
          setReasonVisitError("Reason is required")
      }      
      else if (reasonVisit.length>60)
      {
          errNo++;
          setReasonVisitError("Reason cannot exceed 60 letters")
      }      
      else 
      {
          setReasonVisitError('')
      }

      if (remarks && remarks.length>100)
      {
          errNo++;
          setRemarksError("Remarks cannot exceed 100 letters")
      }

      if (errNo>0)
      {
          setActiveStep(1)
          return
      }

      body.floor=site
      body.reason=reasonVisit
      body.remarks = remarks;

      if (currentStep===1)
      {
         setActiveStep(x=>x+1)
         return
      }
      

      body.type= myGroup ? 'GROUP': 'NORMAL';
      if (myGroup)
      {
          body.invitationVisitors=[]
          const  iGroupSize  = parseInt(groupSize, 10);
          if (isNaN(iGroupSize) || iGroupSize<1) 
          { 
            setGroupSizeError("Invalid group size");
            errNo++; 
          }
          else if (!isNaN(vmsConfig.maxGroupSize) && groupSize>vmsConfig.maxGroupSize)
          { 
            setGroupSizeError(`Group size exceeds limit of ${vmsConfig.maxGroupSize}`);
            errNo++; 
          }
          else {
            setGroupSizeError("");
            body.groupMaxPerson = groupSize;
          }
          if (!Boolean(groupSendTo))
          {
              errNo++; 
              setGroupSendToError("Group Email is required")
          }
          else if (!groupSendTo.match(regexEmail))
          {
              errNo++; 
              setGroupSendToError("Invalid Group Email")
          }
          else 
          {
            setGroupSendToError("")
            body.groupSendToEmail = groupSendTo
          }
      }
      else
      {
          body.type="NORMAL"
          if (!listData||listData.length===0)
          {
              errNo++
          }
          else
          {
            body.invitationVisitors = listData;

            if (action==='create' || action==='reinvite'|| action==='invite')
            {
                body.invitationVisitors.forEach(x=>{
                    delete x.id})
            }
          }
      }

      if (errNo>0) return
      try
      {
        setStatus('processing')
        //let x = await apply();

        let app = body
        
        //alert(JSON.stringify(body))
        
        console.log(body)
        //return
        let app1 = await dispatch(createApplication(app)).unwrap()
        console.log("done---------------------");
        console.log(app1);

        setStatus('success')
        
        navigate("/invitations")
        openSnackToast("Your invitation has been successfully scheduled")
      }
      catch (ex){
        setErrorMessage(ex.message)
        setStatus('error')
        console.error("xxx::"+ex.message);

      }
      
  }

  const showReoccurence =()=>{
      setOp('reoccurence')


  }
  const completeReoccurence =(data)=>{
    setOp('')
    //alert("completeReoccurence")

    if (data)
    {
      setReoccurence(data)
      setReoccurenceError('')
    }
  }

  
  const enanbledClick = myGroup || (listData && listData.length>0)

  return (
    <Box>

      <Box sx={{ py:1,my:1, display:'flex', justifyContent:'center', width:'100%', border:0}}>
          <Box sx={{ width: {xs:'90%',sm:'80%', md:'60%', lg:'50%'} , 
                bgcolor:'#ffffff',  p:1, border:1, borderColor:"#dddddd"}}>
              <Stepper activeStep={activeStep} sx={{bgcolor:'white', }} alternativeLabel={false}>
                <Step>
                          <StepLabel>
                            <>Time</>
                          </StepLabel>
                  </Step>
                  
                  <Step>
                          <StepLabel>
                            <>Purpose & Floor</>
                          </StepLabel>
                  </Step>
                  <Step>
                          <StepLabel>Visitors</StepLabel>
                  </Step>
                  
            </Stepper>
          </Box>
      </Box>
      <Paper sx={{border:'none', justifyContent: "flex-start", px:2, py: 1, 
            bgcolor:'none'}} elevation={0} >
        
        {activeStep===0 &&
          <React.Fragment>

            <Box sx={{width:'100%',  display:'flex', justifyContent:'center', }}>
                  <FormControl sx={{ bgcolor:'@@red'}}>
                        <RadioGroup
                                size='small'
                                row
                                onChange={event => onTimeModeChanged(event.target.value)}
                                value={timeMode}
                                >
                            <FormControlLabel 
                                size='small'
                                sx={{ mr:{xs:5, sm:8, md:12}}}
                                value="normal" control={<Radio />} label="Single Occurrence" />

                            <FormControlLabel 
                                size='small'
                                value="reoccurence" control={<Radio />} label="Recurrence" />
            
                        </RadioGroup>
                    </FormControl>
                
            </Box>
            <hr/>
          {timeMode==='normal' &&

          <Grid
            container
            spacing={2}
            direction={'row'}
            alignItems={'center'}
          >

<Grid container item  xs={12} sm={12}  md={6}   sx={{px:0}} spacing={2}>
              <Grid item xs={1} sm={2}  >
              </Grid>

             <Grid item xs={5}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                                value={startDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setStartDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(startDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ startDateError?startDateError:'DD/MM/YYYY' } 
                                              label="Start Date"
                                              //value={nestartDateTime}
                                              //onChange={(newValue) => {  setStartDateTime(newValue);}
                                            
                                            
                            
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={5} sm={4}   sx={{px:1}}>
                <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_start_timr" 
                      value={startTime}
                options={allStartTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setStartTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setStartTime(e.target.value);}}
                        error={Boolean(startTimeError)}
                        label="Start Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(startTimeError) ? startTimeError : "HH:mm"}
                      />}

                /> 
                  {/*<FormControl required  fullWidth size="small">
                     <InputLabel id="id_start_time_label" size='sm'>Start Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_tart_time_label"
                            error={Boolean(startTimeError)}
                            id="id_tart_time"
                            value={startTime}
                            label={"Start Time"}
                            onChange={(e)=>setStartTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allStartTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(startTimeError) }>
                          {Boolean(startTimeError) ?startTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}
                  
                </Grid>
            </Grid>
            <Grid container item  xs={12} sm={12}  md={6}   sx={{px:0}} spacing={2}>
              <Grid item xs={1} sm={2}  md={1} lg={1}>
                </Grid>

             <Grid item xs={5}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker 
                                value={endDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setEndDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(endDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ endDateError ?  endDateError :'DD/MM/YYYY'}
                                              label="End Date"
                                              //value={nestartDateTime}
                                              //onChange={(newValue) => {  setStartDateTime(newValue);}
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={5} sm={4}  sx={{px:1}}>
                  {/* <FormControl required  fullWidth  size="small">
                    <InputLabel id="id_end_time_label" size='sm'>End Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_end_time_label"
                            error={Boolean(endTimeError)}
                            id="id_end_time"
                            value={endTime}
                            label={"End Time"}
                            onChange={(e)=>setEndTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allEndTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(endTimeError) }>
                          {Boolean(endTimeError) ?endTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}

                    <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_end_timr" 
                      //popupIcon={<ArrowDropDownIcon />}
                value={endTime}
                options={allEndTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setEndTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setEndTime(e.target.value);}}
                        error={Boolean(endTimeError)}
                        label="End Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(endTimeError) ? endTimeError : "HH:mm"}
                      />}

                /> 
                  </Grid>
              </Grid>
          </Grid>
          }
          {timeMode==='reoccurence' &&
            <>
            {
                  op!=='reoccurence' &&
                  <React.Fragment>
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    <Typography variant="subtitle1"><strong>Recurrence :&nbsp;</strong></Typography>
                    <Link component="button" 
                          variant="subtitle1"
                          onClick={showReoccurence}
                          sx={{bgcolor:'', fontWeight:555}}
                          >{reoccurence?.message?reoccurence?.message:'Please define frequency'}</Link>
                  </Box>
                  { 
                      Boolean(reoccurenceError) &&
                  
                  <Box sx={{mt:2, display:'flex', justifyContent:'center'}}>
                    <Typography variant="h6" color='error'><strong>{reoccurenceError}</strong></Typography>
                    
                  </Box>
                  }
                  <Box sx={{display:'flex', mt:1, justifyContent:'center', }}>
                    { reoccurence&& reoccurence.days && reoccurence.days.length>0 && 
                      <>
                      <Accordion disableGutters dense 
                          sx={{width:'100%', p:0, border:0, m:1, bgcolor:'#f4f4ff'}}>
                        <AccordionSummary 
                          sx={{p:0,m:0}}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography sx={{pl:2}}><strong>Scheduled Date Time(s)</strong></Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{p:0, m:0}}>
                        
                    <Grid container spacing={1} alignItems="center">
                        {
                            reoccurence.days.map((d,i)=>
                              (<Grid item key={i}  
                                sx={{m:0}}
                                xs={12} sm={6} md={4} lg={3}
                                  disableGutters>
                                <ListItem variant="subtitle1">
                                  <ClockIcon size='small' sx={{mr:1}}/>{d.text}
                                </ListItem>
                              </Grid>)
                            )


                        }

                    </Grid>
                        </AccordionDetails>
                        </Accordion>
                    
                    </>
                    }
                  </Box>
                  </React.Fragment>
            }
            {
                  op==='reoccurence' &&
                  <>
                  {
                    /**
                  <ReoccurencePage
                      data={reoccurence}
                      callback={completeReoccurence}
                  ></ReoccurencePage>
                                       */
                }

                  <ReoccurenceDialog
                      open={true}
                      data={reoccurence}
                      callback={completeReoccurence}
                  ></ReoccurenceDialog>

                  </>
              }
            
            </>
          }
          </React.Fragment>
      }


    {activeStep===1 &&
        <Grid
              container
              spacing={2}
              direction={'row'}
              alignItems={'center'}
            >
        <Grid item xs={12} sm={6}  lg={4}>
            
            <Autocomplete 
                fullWidth 
                selectOnFocus
                handleHomeEndKeys
                //disableClearable
                id="id_reason" 
                
                value={reasonVisit}
                options={visit_reasons.map((option) => option.reason)} 
                onChange = { (e, newValue)=>{setReasonVisit(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                      required
                      // onChange = { e=>{setReasonVisit(e.target.value);}}
                      error={Boolean(reasonVisitError)}
                      label="Purpose"  
                      //inputProps={{ maxLength: 60, minLength:5 }}
                      helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Purpose of visit (required)"}
                      />}

                />
   
          </Grid>
        
          
          <Grid item xs={12} sm={6}  lg={4} >
              <FormControl required  fullWidth >
                <InputLabel id="id_floor_label" >Floor to Visit</InputLabel>
                    <Select
                        required
                        labelId="id_floor_label"
                        error={Boolean(siteError)}
                        id="id_flooe"
                        value={site}
                        label={"Floor to Visit"}
                        onChange={(e)=>setSite(e.target.value)}
                        
                        >
                      <MenuItem value={''}></MenuItem>
                      
                      {
                          sites.map( (ct)=>
                            (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                          )
                      }
                      
                  </Select>
                    <FormHelperText error={Boolean(siteError) }>
                      {Boolean(siteError) ? siteError:'Please select floor to visit'}
                    </FormHelperText>
                            
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}  lg={4}  sx={{/*bgcolor:{lg:'red', xl:'green', md:'yellow'}*/}}>
            <TextField 
                //required
                fullWidth
                value={remarks}
                error={Boolean(remarksError)}
                id="id_remarks" label="Remarks" type="text" 
                onChange = { e=>setRemarks(e.target.value)}
                inputProps={{ maxLength: 100, minLength:5 }}
                helperText={ Boolean(remarksError) ? remarksError: "Remarks (optional)"}/>
        </Grid>

         </Grid>
      }

{activeStep===2 &&
    <>

      {
      //Kelvin  Oct 25, 2022
      
      !Boolean(op) &&
      <Box sx={{ py:0,mb:1, display:'flex', justifyContent:'center', width:'100%', border:0}}>
      
        <FormControlLabel 
            sx={{bgcolor:'#f1f1f1', px:6}}
            control={<Checkbox
              checked={myGroup}
              disabled={Boolean(visitor_id)}
              onChange={e=>{setMyGroup(e.target.checked);setGroupSendToError(''); setGroupSizeError('');}}
            
            />} label="Group Invitation" />
      </Box>
        }
            { myGroup && 
              <Grid
                  container
                  spacing={2}
                  sx={{mt:1}}
                >
    
              <Grid item xs={12} sm={6}  lg={4} >
            
                <Autocomplete 
                    fullWidth
                    freeSolo
                    selectOnFocus
                    handleHomeEndKeys
                    //disableClearable
                    id="id_send_to" 
                    
                    value={groupSendTo}
                    //options={allEmail} 
                    options={[]} 
                    onChange = { (e, newValue)=>{setGroupSendTo(newValue);   } }
                    renderInput={(params) => 
                        <TextField {...params} 
                          required
                          onChange = { e=>{setGroupSendTo(e.target.value);}}
                          error={Boolean(groupSendToError)}
                          label="Email for Group Invitation"  
                          //inputProps={{ maxLength: 100, minLength:5 }}
                          helperText={ Boolean(groupSendToError) ? groupSendToError : "Email for group invitation"}
                          />}
                    />
              </Grid>
         
              <Grid item xs={12} sm={6}  lg={4}>
                <TextField
                    fullWidth
                    id="id_gropp_size" 
                    required
                    type='number'
                    value={groupSize}
                    error={Boolean(groupSizeError)}
                    label={"Number of visitors"}  
                    onChange={(e)=>{setGroupSize(e.target.value)}}
                    helperText={ 
                        Boolean(groupSizeError) ? groupSizeError : "Max number of visitors up to "+vmsConfig.maxGroupSize}

                    />
      
                    
              </Grid>
          
          
              </Grid>
          
          }


        { !myGroup && <PersonView/>}
        </>
        }
          
        { !Boolean(op) &&
        <Box sx={{mt:2, px:{xs:1, sm:2, md:2, lg:6},
        
            display:'flex',  width:'100%', justifyContent: 'space-between'}}>

            <Button variant="outlined" 
              //variant="contained" 
              //color='success'  
              sx={{textTransform:'none'}}
              disabled = { activeStep===0}
              onClick={e=>{if (activeStep>0) setActiveStep(x=>x-1)}}
            > Back</Button>

            {/* 
            <Button variant="outlined" 
              //variant="contained" 
              color='success'  
              sx={{textTransform:'none'}}
              disabled = { !enanbledClick || activeStep!==2 }
              onClick={onSendInviteClicked}
            > Sent Invitaion</Button>
            */}
            <Button variant="outlined" 
                sx={{textTransform:'none'}}
                //variant="contained" 
                color='success'
              //disabled = {status==='success'}
              onClick={onCancelClicked}
            > Cancel</Button>

            <Button variant="outlined" 
              //variant="contained" 
              //color='success'  
              sx={{textTransform:'none'}}
              disabled = { activeStep==2 && !myGroup && (!listData|| listData.length==0)}
              onClick={e=>onSendInviteClicked(activeStep)}
            > 
              {activeStep===2?'Send Invitation' :'Next'} 
            </Button>

        </Box>
      }
      </Paper>
      

      
    </Box>
  );
};

const ApplyPage = ( {action}) => {

  const {invitation_id, visitor_id}=useParams()
  const location = useLocation()
  console.log("locatiom="+location.pathname)

  



  return(
    <DataListProvider>
      <ApplyPageInternal  action={action} 
          visitor_id={visitor_id} invitation_id={invitation_id}/>
    </DataListProvider>
    )
}
export default ApplyPage;
